exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".point {\n  border: 1px solid rgba(0, 0, 0, 0.5);\n  margin-bottom: 4px;\n  padding: 4px;\n  border-radius: 4px;\n  -webkit-border-radius: 4px;\n  -moz-border-radius: 4px;\n}\n.point-name {\n  font-weight: bold;\n  font-size: 1.25rem;\n}\n.point-pos {\n  font-style: italic;\n}\n.point-time {\n  font-size: 0.9rem;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/locations/locations-home.component.less
// module id = ./src/app/locations/locations-home.component.less
// module chunks = 0